import { Text, VStack } from "@gluestack-ui/themed";
import { Icon } from "@repo/core/components/core/Icon";
import { Pressable } from "@gluestack-ui/themed";

import { ShareItemOptionProps } from "./types";
import { PressableProps } from "@repo/core/components/core/Shortcuts/types";

export const ShareItemOption = ({
  icon,
  label,
  onPress
}: ShareItemOptionProps) => {
  return (
    <Pressable
      flexDirection="row"
      p="$3"
      alignItems="center"
      $hover-backgroundColor="$secondary50"
      $pressed-backgroundColor="$secondary50"
      gap="$2"
      onPress={onPress}
    >
      {({ hovered, pressed }: PressableProps) => {
        const active = hovered || pressed;
        return (
          <>
            <VStack>
              <Icon
                name={icon}
                variant="solid"
                size={24}
                color={active ? "$primary700" : "$textLight800"}
              />
            </VStack>
            <VStack flex={1}>
              <Text
                fontSize="$md"
                fontWeight={600}
                color={active ? "$primary700" : "$textLight800"}
              >
                {label}
              </Text>
            </VStack>

            <VStack>
              <Icon
                name="chevron-right"
                size={24}
                color={active ? "$primary700" : "$textLight800"}
              />
            </VStack>
          </>
        );
      }}
    </Pressable>
  );
};
